/**
 * Modal de confirmación para disparar manualmente la reconciliación de NS de una fecha
 * específica, sin esperar la corrida automática de la madrugada.
 *
 * A diferencia de MarcarRevisadoModal (que solo deja constancia de una revisión), esta
 * acción SÍ dispara escritura real en producción (encola guías en Service Bus para
 * marcarse "Desasociada"), por lo que se exige una confirmación explícita antes de
 * ejecutar (ver docs_myspread/revision_ns/Adicion_Trigger_Manual_Por_Fecha.md, §3).
 */

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { formatFecha } from '../utils/helpers';

const EjecutarReconciliacionManualModal = ({ show, onHide, fecha, onConfirm, loading }) => {
  if (!show) return null;

  const handleCancel = () => {
    if (loading) return;
    onHide();
  };

  return (
    <Modal show={show} onHide={handleCancel} size="md" centered backdrop={loading ? 'static' : true}>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>
          <FaIcons.FaPlayCircle className="me-2" />
          Ejecutar reconciliación manual
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-warning">
          <strong>Fecha a reconciliar:</strong> {formatFecha(fecha)}
        </div>
        <p>
          Esta acción compara la fecha seleccionada contra DispatchTrack y marca como{' '}
          <strong>Desasociada</strong> las guías que ya no correspondan a su ruta — es el
          mismo proceso que corre automáticamente todos los días a la 01:00, ejecutado ahora
          bajo demanda.
        </p>
        <p className="mb-0">
          Es una acción real sobre datos de producción, no un filtro de pantalla. Al confirmar,
          la solicitud se encola y se procesa en background — no es necesario esperar en esta
          pantalla. El resultado se reflejará más tarde en la tabla de abajo (si se detectan
          rutas no encontradas en DispatchTrack) y en el resumen diario por correo.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <FaIcons.FaSpinner className="fa-spin me-2" />
              Encolando solicitud...
            </>
          ) : (
            <>
              <FaIcons.FaPlayCircle className="me-2" />
              Confirmar ejecución
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EjecutarReconciliacionManualModal;
